import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const container = css`
  > :empty {
    display: none;
  }
`;

export const pricingBox = css`
  padding: 0.5rem;
  @media screen and (max-width: ${dimensions.phoneLargeMax}) {
    padding: 0.5rem;
  }
`;

export const pricing = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  gap: 0.25rem;
`;
